import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const LogoWrap = styled.div`
  &.withText {
    margin-bottom: 104px;
  }
`;

export const LogoBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const LogoImage = styled.img`
  display: block;
`;

export const LogoText = styled.h3`
  margin-left: 25px;
  font-size: 36px;
  color: ${themeGet('colors.secondary.regular')};
  font-weight: ${themeGet('fontWeights.bold')};
`;
